import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon from "./Icon";


const SocialLink = ({url, type, transparent}) => (
    <a
        href={url}
        className={classNames('social--link', {'social--link--transparent': transparent})}
    >
        <Icon type={`social--${type}`} className={classNames({'icon--white': transparent})} />
    </a>
);

SocialLink.propTypes = {
    url: PropTypes.string.isRequired,
    type: PropTypes.oneOf(['facebook', 'twitter', 'instagram']).isRequired,
    transparent: PropTypes.bool,
};

SocialLink.defaultProps = {
    transparent: false,
};

export default SocialLink;



// WEBPACK FOOTER //
// ./src/components/SocialLink.js